export enum ErrorCode {
    PERSONAL_CODE_EXISTS = 'personal_code_exists',
    ADDING_LARGE_CLIENT_MANAGER_USER_NOT_ALLOWED = 'adding_large_client_manager_user_not_allowed',
    INVALID_LARGE_CLIENT_MANAGER_USER_ID = 'invalid_large_client_manager_user_id',
    MANAGER_USER_NOT_ALLOWED = 'manage_user_not_allowed',
    DELETE_USER_NOT_ALLOWED = 'delete_user_not_allowed'
}
